import OadpEntityForm from './oadp-entity-form';
export default OadpEntityForm;
